import { render, staticRenderFns } from "./addEvent.vue?vue&type=template&id=4e4465bc&scoped=true&"
import script from "./addEvent.vue?vue&type=script&lang=js&"
export * from "./addEvent.vue?vue&type=script&lang=js&"
import style0 from "./addEvent.vue?vue&type=style&index=0&id=4e4465bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4465bc",
  null
  
)

component.options.__file = "addEvent.vue"
export default component.exports